/**
 * Updating sort list order
 */

export const USAGE_DEFINING = 'Defining';
export const USAGE_DESCRIPTIVE = 'Descriptive';
export const USAGE_OFFER = 'Offer';
export const USAGE_DISPLAY = 'Display';
export const ATTR_PICKUP_IN_STORE = 'PickUpInStore';
export const STRING_TRUE = 'true';
export const RA_EXCLUSIVE = 'Exclusive';
export const PRODUCT_LIST_DEFAULT_PAGE_SIZE = 28;
export const SWATCH = 'swatch';
export const RADIO = 'radio';

type Option = {
	key: string;
	value: string;
	translationKey:
		| 'relevance'
		| 'brands'
		| 'name'
		| 'priceLowToHigh'
		| 'priceHighToLow'
		| 'bestSeller';
};

export const SORT_OPTIONS = {
	defaultSortOptions: [
		{
			key: 'SN_NO_SORT',
			value: '0',
			translationKey: 'relevance',
		},
	] as Option[],
	productSortOptions: [
		{
			key: 'SN_SORT_BY_NAME',
			value: '2',
			translationKey: 'name',
		},
		{
			key: 'SN_SORT_BY_BRANDS',
			value: '1',
			translationKey: 'brands',
		},
	] as Option[],
	priceSortOptions: [
		{
			key: 'SN_SORT_LOW_TO_HIGH',
			value: '3',
			translationKey: 'priceLowToHigh',
		},
		{
			key: 'SN_SORT_HIGH_TO_LOW',
			value: '4',
			translationKey: 'priceHighToLow',
		},
	] as Option[],
	otherSortOptions: [
		{
			key: 'SN_SORT_BY_BEST_SELLER',
			value: '5',
			translationKey: 'bestSeller',
		},
	] as Option[],
};
